// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HlqBf","colBig":"styles_colBig__2hYDR","colSmall":"styles_colSmall__3Sbue","shopifyNameWrapper":"styles_shopifyNameWrapper__1PRso"};